module.exports = __webpack_public_path__ + "7ea7f5fe5e3ed56efc701b20d0db6a07.svg";